var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"loading":"lazy","data-src":"/src/assets/img/click.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }